export default __webpack_public_path__ + "static/media/723.9b02c138.png";